module.exports = __webpack_public_path__ + "img/opera_card3.58dd71b9.png";